import { render } from "./GoalCreationActivity.vue?vue&type=template&id=5142c422"
import script from "./GoalCreationActivity.vue?vue&type=script&lang=js"
export * from "./GoalCreationActivity.vue?vue&type=script&lang=js"
script.render = render

export default script